import styled from 'styled-components';
import { sectionTitle } from '../../theme/typography';

export const StyledHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
  min-height: 28px;
  @media only screen and (max-width: 1199px) {
    margin-bottom: 10px;
  }
`;

export const StyledTitle = styled.h2`
  ${sectionTitle};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledAction = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
